import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const VOTE_COLOR = { aye: "#10B981", no: "#EF4444" };

export function PoliticianGridCard({ p, surface, text, textSec, border }) {
  const navigate = useNavigate();
  const ayeCount = p.key_votes?.filter((v) => v.vote === "aye").length || 0;
  const noCount  = p.key_votes?.filter((v) => v.vote === "no").length  || 0;
  const total    = p.key_votes?.length || 0;

  return (
    <button
      onClick={() => navigate(`/politicians/${p.id}`)}
      data-testid={`politician-card-${p.id}`}
      className="text-left border-2 border-black p-0 overflow-hidden hover:-translate-y-1 transition-transform group"
      style={{ backgroundColor: surface, boxShadow: "3px 3px 0 #000" }}
    >
      <div className="h-1.5" style={{ backgroundColor: p.party_color }} />
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <div>
            <p className="font-black text-base leading-tight" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>{p.name}</p>
            <p className="text-xs mt-0.5" style={{ color: textSec }}>{p.role}</p>
          </div>
          <ChevronRight className="w-4 h-4 flex-shrink-0 mt-0.5 group-hover:translate-x-0.5 transition-transform" style={{ color: textSec }} />
        </div>
        <div className="flex items-center gap-2 flex-wrap mb-3">
          <span className="text-xs font-black px-2 py-0.5 border-2 border-black text-white" style={{ backgroundColor: p.party_color }}>{p.party_name}</span>
          <span className="text-xs font-semibold" style={{ color: textSec }}>
            {["House of Representatives", "House of Assembly", "Legislative Assembly"].includes(p.chamber) ? "House" : "Senate/Council"} · {p.state}
          </span>
        </div>
        {p.electorate && <p className="text-xs mb-3" style={{ color: textSec }}><span className="font-bold">Electorate:</span> {p.electorate}</p>}
        {total > 0 && (
          <div className="flex items-center gap-3 mt-2 pt-3 border-t-2" style={{ borderColor: border }}>
            <div className="flex items-center gap-1">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: VOTE_COLOR.aye }} />
              <span className="text-xs font-black" style={{ color: VOTE_COLOR.aye }}>{ayeCount} Aye</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: VOTE_COLOR.no }} />
              <span className="text-xs font-black" style={{ color: VOTE_COLOR.no }}>{noCount} No</span>
            </div>
            <span className="text-xs ml-auto" style={{ color: textSec }}>{total} votes on record</span>
          </div>
        )}
      </div>
    </button>
  );
}
